import script from "./TheTable.vue?vue&type=script&setup=true&lang=js"
export * from "./TheTable.vue?vue&type=script&setup=true&lang=js"

import "./TheTable.vue?vue&type=style&index=0&id=e73d0aaa&lang=scss"

const __exports__ = script;

export default __exports__